blogHandler = {
    $blogContainer = $('.blog-content-container'),
    $tempBlogContainer = $('.temp-blog-content-container'),
    $contentPaging = $('.content-pagination'),
    $contentContainer = $('.content-item-container'),
    $perPage = $('.content-pagination').data('per-page'),
    $clearCategoryFilter = $('.clear-category-filter'),
    $filterContainer = $('.filter-container'),
    $gridFilter = $('.grid-filter'),

    loadBlogContent = function(category=null) {
        var self = this;

        if (this.$blogContainer.find('.content-item-container').length > 0) {
            this.$blogContainer.empty();
        }
        
        var content = '';
        if (category) {
            content = '.content-item-container[data-category='+category+']';

            self.$filterContainer.removeClass('hide');
            self.$filterContainer.find('.text-category').text('Filtering by “'+category+'”');
        } else {
            content = '.content-item-container';

            self.$filterContainer.addClass('hide');
            self.$filterContainer.find('.text-category').text('');
        }

        var counter = 0;
        var pageId = 1;
        this.$tempBlogContainer.find(content).each(function() {
            if (counter > 0 && counter % self.$perPage == 0) {
                pageId++;
            }
            
            counter++;

            var tempContent = $(this).clone();

            tempContent.data('page-id', pageId);

            if (pageId > 1) {
                $(tempContent).addClass('hide');
            }

            $(tempContent).appendTo(self.$blogContainer);

            $(tempContent).find('.blog-category-button').on('click', function() {
                var blogCat = $(this).data('category');
    
                homeHandler.scrollTo(self.$gridFilter, 600);

                setTimeout(function() {
                    self.loadBlogContent(blogCat);
                }, 500);
            });
        });


        this.$contentPaging.empty();
        $clonedPaging = this.$contentPaging.clone();
        var childName = $clonedPaging.data('child-name');
        
        for(var i=1; i <= pageId; i++) {
            $child = document.createElement('a');
            $child.className = childName;
            $($child).text(i);

            if (i == 1) {
                $($child).addClass('is-current');
            }

            $($child).data('page-id', i);

            $($child).appendTo($clonedPaging);
        }

        
        $($clonedPaging).appendTo(this.$blogContainer);
        
        $($clonedPaging).find('.'+childName).on('click', function() {
            var pageId = $(this).data('page-id');

            $($clonedPaging).find('.'+childName).removeClass('is-current');
            $(this).addClass('is-current');

            self.$blogContainer.find('.content-item-container').each(function() {
                var tempPageId = $(this).data('page-id');
                if (tempPageId != pageId) {
                    $(this).addClass('hide');
                } else {
                    $(this).removeClass('hide');
                }
            });
            homeHandler.scrollTo($gridFilter);
        });
        homeHandler.scrollTo($gridFilter);
    },

    init = function(){
        var self = this;

        var hash = window.location.hash.replace('#', '');

        self.loadBlogContent(hash);

        self.$clearCategoryFilter.on('click', function() {
            self.loadBlogContent();
        });
    }
}